module.exports = __webpack_public_path__ + "img/logout-red.8abe0150.svg";